import { initAccordion } from "./accordion";
import { initImageModal } from "./imageModal";

function run() {
  initAccordion();
  initImageModal();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", run, { once: true });
} else {
  run();
}
